<template>
  <div class="layout">
    <div class="main">
      <slot name="main"></slot>
    </div>
    <div class="sidebar">
      <div class="head">
        <slot name="head"></slot>
      </div>
      <slot name="secondary"></slot>
    </div>
  </div>
</template>

<style lang="postcss" scoped>
.layout {
  @apply bg-white;
  display: grid;
  grid-template-columns: 3fr 2fr;
  grid-template-rows: auto;
  grid-template-areas: 'main sidebar';
  color: var(--resume-font-color);
  font-family: var(--resume-font-family);
  padding: var(--resume-margin);
  line-height: var(--resume-line-height);
  :deep(h1),
  :deep(h2),
  :deep(h3) {
    @apply font-bold;
    color: var(--resume-primary-color);
    font-family: var(--resume-font-family);
  }

  .sidebar,
  .main,
  .head {
    grid-area: sidebar;
    @apply bg-transparent;
  }

  .sidebar,
  .main {
    @apply pt-0;
  }
  .head {
    grid-area: sidebar;
  }
  .main {
    @apply pl-8-em;
    grid-area: main;
  }
  .sidebar {
    @apply pr-8-em;
    background-color: var(--resume-background-color);
    background: linear-gradient(
      180deg,
      var(--resume-background-color) 0%,
      var(--resume-background-color) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    grid-area: sidebar;
    .head {
      @apply p-0 mt-6-em;
    }
  }
}
</style>
